<!-- Vehicle Bid Manager -->
<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center my-1">
        <i class="ki-duotone ki-chart-line-up fs-2 me-3">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <h3 class="fw-bold m-0">VEHICLE BID MANAGER</h3>
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <!-- Cancel All Bids Button - shown only when bids are selected -->
        <button
          *ngIf="selectedBids.length > 0"
          type="button"
          class="btn btn-danger btn-sm me-3"
          (click)="cancelAllSelectedBids()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Cancel All Bids ({{ selectedBids.length }})
        </button>

        <button type="button" class="btn btn-primary btn-sm me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
          <span *ngIf="activeFiltersCount > 0" class="badge badge-danger ms-2">{{ activeFiltersCount }}</span>
        </button>
        <button type="button" class="btn btn-sm btn-primary me-3 text-nowrap" (click)="exportExcel()" [disabled]="isExportingExcel">
          <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isExportingExcel" class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingExcel ? 'Exporting...' : 'Export' }}</span>
        </button>
        <button type="button" class="btn btn-light btn-sm" (click)="clearFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div *ngIf="showFiltersForm" class="card-body border-top">
    <div class="row g-4">
      <!-- Date Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Date</h6>
          <div class="filter-options">
            <!-- All Checkbox -->
            <div class="form-check form-check-custom form-check-solid mb-3 pb-2 border-bottom">
              <input class="form-check-input"
                     type="checkbox"
                     id="date_all"
                     [checked]="isAllDatesChecked()"
                     (change)="onDateAllChange($any($event.target).checked)">
              <label class="form-check-label fw-bold text-gray-800"
                     for="date_all">
                All
              </label>
            </div>
            <!-- Individual Date Checkboxes -->
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let date of dateOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'date_' + date.value"
                     [checked]="date.checked"
                     (change)="onFilterChange('dates', date.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'date_' + date.value">
                {{ date.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Make Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Make</h6>
          <div class="filter-options">
            <div *ngIf="isLoadingMakes" class="text-center py-2">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="ms-2 small">Loading...</span>
            </div>
            <div *ngIf="!isLoadingMakes && makeOptions.length === 0"
                 class="text-muted py-2 small">
              No makes found
            </div>
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let make of makeOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'make_' + make.value"
                     [checked]="make.checked"
                     (change)="onFilterChange('makes', make.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'make_' + make.value">
                <span [innerHTML]="formatLabelWithCount(make.label)"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Sales Person Filter -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Sales Person</h6>
          <div class="filter-options">
            <div *ngIf="salesPersonOptions.length === 0"
                 class="text-muted py-2 small">
              No sales persons found
            </div>
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let person of salesPersonOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'person_' + person.value"
                     [checked]="person.checked"
                     (change)="onFilterChange('salesPersons', person.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'person_' + person.value">
                {{ person.label }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Status and Lot No Filter Column -->
      <div class="col-lg-2 col-md-4 col-sm-6">
        <!-- Status Filter -->
        <div class="filter-section mb-4">
          <h6 class="fw-bold text-gray-800 mb-3">Status</h6>
          <div class="filter-options">
            <div class="form-check form-check-custom form-check-solid mb-2"
                 *ngFor="let status of statusOptions">
              <input class="form-check-input"
                     type="checkbox"
                     [id]="'status_' + status.value"
                     [checked]="status.checked"
                     (change)="onFilterChange('statuses', status.value, $any($event.target).checked)">
              <label class="form-check-label fw-semibold text-gray-700"
                     [for]="'status_' + status.value">
                {{ status.label }}
              </label>
            </div>
          </div>
        </div>

        <!-- Lot No Filter -->
        <div class="filter-section">
          <h6 class="fw-bold text-gray-800 mb-3">Lot No</h6>
          <div class="filter-options">
            <input type="text"
                   class="form-control form-control-sm"
                   [(ngModel)]="filters.lotNumbers"
                   (input)="onFilterChange('lotNumbers', $any($event.target).value, true)"
                   placeholder="Enter lot numbers with comma separated e.g 7009, 2435">
          </div>
        </div>
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="row mt-4">
      <div class="col-12">
        <button type="button" class="btn btn-primary btn-sm me-3" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Apply Filters
        </button>
        <button type="button" class="btn btn-light btn-sm" (click)="clearFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Results Summary -->
  <div class="card-body pt-0">
    <!-- <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="text-muted">
        <strong>Total Records Found: {{ paginationInfo.total }}</strong>
      </div>
      <div class="d-flex align-items-center">
        <span class="text-muted me-3">Records Per Page</span>
        <select class="form-select form-select-sm w-auto">
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div> -->

    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mt-3">Loading bids...</p>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && bids.length === 0" class="text-center py-5">
      <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-3">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
      <h5 class="text-muted">No bids found</h5>
      <p class="text-muted">Try adjusting your search criteria or filters.</p>
    </div>

    <!-- Bids Grid Layout -->
    <div *ngIf="!isLoading && bids.length > 0" class="bid-manager-grid">
      <!-- Header Row with Checkboxes -->
      <div class="d-flex align-items-center mb-4 p-3 bg-light rounded">
        <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            (change)="toggleAllSelection($event)">
        </div>
        <span class="fw-bold text-muted fs-5">Select All Bids</span>
        <div class="ms-auto">
          <span class="text-muted fw-bold fs-6">Page {{ paginationInfo.currentPage }} of {{ paginationInfo.lastPage }}</span>
        </div>
      </div>

      <!-- Bid Cards Grid -->
      <div class="row g-4" *ngFor="let bid of bids; trackBy: trackByFn; let i = index">
        <div class="col-12" >
          <div class="card bid-card" [class.selected]="isSelected(bid._id)">
            <div class="card-body p-4">
              <div class="row align-items-center">
                <!-- Selection Checkbox -->
                <div class="col-auto">
                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [value]="bid._id"
                      [checked]="isSelected(bid._id)"
                      (change)="toggleSelection(bid._id, $event)">
                  </div>
                </div>

                <!-- Vehicle Images -->
                <div class="col-md-2">
                  <div class="vehicle-images-container">
                    <div class="main-image mb-2">
                      <img [src]="getMainImage(bid.car)"
                           [alt]="bid.car.name"
                           class="img-fluid rounded"
                           style="height: 120px; width: 100%; object-fit: cover;"
                           onerror="this.src='assets/media/stock/600x400/img-1.jpg'">
                    </div>
                    <div class="thumbnail-images d-flex" *ngIf="bid.car.pictures && bid.car.pictures.length > 1">
                      <img *ngFor="let pic of bid.car.pictures.slice(1, 4); let idx = index"
                           [src]="pic"
                           [alt]="bid.car.name + ' - ' + (idx + 2)"
                           class="img-thumbnail me-1"
                           style="height: 30px; width: 30px; object-fit: cover;"
                           onerror="this.src='assets/media/stock/600x400/img-1.jpg'">
                      <span *ngIf="bid.car.pictures.length > 4"
                            class="badge badge-light-primary ms-1 d-flex align-items-center justify-content-center"
                            style="height: 30px; width: 30px; font-size: 10px;">
                        +{{ bid.car.pictures.length - 4 }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Vehicle Information -->
                <div class="col-md-2">
                  <div class="vehicle-info" (click)="goToVehicleDetails(bid)" style="cursor: pointer;">
                    <h6 class="fw-bold text-dark mb-1">{{ bid.car.company_name }}</h6>
                    <p class="text-muted mb-1">{{ bid.car.name }}</p>
                    <div class="d-flex flex-wrap gap-2 mb-2">
                      <span class="badge badge-light-info">{{ bid.car.year }}</span>
                      <span class="badge badge-light-secondary">{{ bid.car.engine }}</span>
                      <span class="badge badge-light-success">{{ bid.car.transmission }}</span>
                    </div>
                    <div class="text-muted">
                      <div class="mb-1"><strong>Mileage:</strong> {{ bid.car.mileage | number }} km</div>
                      <div class="mb-1"><strong>Color:</strong> {{ bid.car.color }}</div>
                      <div class="mb-1"><strong>Fuel:</strong> {{ bid.car.fuel_type }}</div>
                    </div>
                  </div>
                </div>

                <!-- Auction Details -->
                <div class="col-md-2">
                  <div class="auction-details">
                    <h6 class="fw-bold text-primary mb-1">{{ bid.car.lot_no }}</h6>
                    <p class="text-muted mb-1">{{ bid.car?.hall_name || 'N/A' }}</p>
                    <div class="text-muted">
                      <div class="mb-1"><strong>Auction Date:</strong></div>
                      <div class="mb-2">{{ formatDate(bid.car.auction_date) }}</div>
                      <div class="mb-1"><strong>Bid Date:</strong></div>
                      <div class="mb-2">{{ formatDate(bid.created_at) }}</div>
                      <div class="mb-1"><strong>Destination Country:</strong></div>
                      <div class="mb-2">{{ bid.to_country?.name || 'N/A' }}</div>
                      <div class="mb-1"><strong>Destination Port:</strong></div>
                      <div>{{ bid.to_port?.name || 'N/A' }}</div>
                    </div>
                  </div>
                </div>

                <!-- Pricing Information -->
                <div class="col-md-2">
                  <div class="pricing-info">
                    <div class="mb-2">
                      <label class="text-muted small">Start Price</label>
                      <div class="fw-bold">{{ formatCurrency(parseInt(bid.car?.price || "0"), 'JPY') }}</div>
                    </div>
                    <div class="mb-2">
                      <label class="text-muted small">Your Bid</label>
                      <div class="fw-bold text-primary">{{ formatCurrency(bid.bid_amount, bid.currency) }}</div>
                    </div>
                    <div class="mb-2" *ngIf="bid.price_type && bid.price_type_amount">
                      <label class="text-muted small">{{ bid.price_type }} Price</label>
                      <div class="fw-bold text-info">{{ formatCurrency(bid.price_type_amount, bid.currency) }}</div>
                    </div>
                    <div class="mb-2" *ngIf="bid.client">
                      <label class="text-muted small">Client</label>
                      <div class="fw-semibold text-dark">{{ bid.client.title }} {{ bid.client.name }}</div>
                    </div>
                    <div *ngIf="bid.result_amount">
                      <label class="text-muted small">Result</label>
                      <div class="fw-bold text-success">{{ formatCurrency(bid.result_amount, 'JPY') }}</div>
                    </div>
                  </div>
                </div>

                <!-- Status Information -->
                <div class="col-md-2">
                  <div class="status-info">
                    <div class="mb-3">
                      <span class="badge fs-6" [class]="getStatusBadgeClass(bid.status)">
                        {{ bid.status | titlecase }}
                      </span>
                    </div>
                    <div class="mb-2">
                      <span class="badge badge-light-info">{{ bid.group }}</span>
                    </div>
                    <div class="mb-2">
                      <label class="text-muted small">Units</label>
                      <div class="fw-bold">{{ getUnitDisplayText(bid) }}</div>
                    </div>
                    <div class="text-muted">
                      <div class="mb-1"><strong>Created by:</strong></div>
                      <div class="mb-1">{{ bid.created_by.name }}</div>
                      <div>{{ bid.created_by.email }}</div>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons - Moved to the right -->
                <div class="col-md-1">
                  <div class="action-buttons d-flex justify-content-end">
                    <div class="d-flex gap-2">
                      <!-- Edit Button -->
                      <button class="btn btn-sm btn-light-warning"
                              type="button"
                              data-bs-toggle="tooltip"
                              title="Edit Bid"
                              (click)="editBid(bid)">
                        <i class="ki-duotone ki-pencil fs-5">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </button>

                      <!-- Document Button -->
                      <button class="btn btn-sm btn-light-info"
                              type="button"
                              data-bs-toggle="tooltip"
                              title="View Documents"
                              (click)="viewDocuments(bid)">
                        <i class="ki-duotone ki-document fs-5">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </button>

                      <!-- Calculator Button -->
                      <button class="btn btn-sm btn-light-success"
                              type="button"
                              data-bs-toggle="tooltip"
                              title="Calculate Costs"
                              (click)="calculateCosts(bid)">
                        <i class="ki-duotone ki-calculator fs-5">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Message Row - shown only if bid has a message -->
              <div *ngIf="bid.message && bid.message.trim()" class="row mt-3">
                <div class="col-12">
                  <div class="alert alert-light-primary d-flex align-items-center">
                    <i class="ki-duotone ki-message-text-2 fs-4 text-primary me-3">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                    <div>
                      <span class="text-muted fw-bold fs-6">Comment:</span>
                      <span class="ms-2 fs-6">{{ bid.message }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && bids.length > 0" class="mt-5">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Edit Bid Modal -->
<app-vh-update-bid #updateBidModal (bidUpdated)="onBidUpdated()"></app-vh-update-bid>
